/*
Perhaps, use @JsonProperty decorator package?
 */

export interface IOrderProduct {
  name: string;
  sku: string;
  qty: number;
  image: string;
  url: string;
  terms_and_conditions_file_path: string;
}

export interface IOrderModel {
  order_number?: string;
  increment_id?: string;
  created_at?: string;
  updated_at?: string;
  office_code?: string;
  status?: string;
  expanded?: boolean;
  shown?: boolean;
  link_to_order_pdf?: string;
  products: IOrderProduct[];
}

export interface IOrderConfig {
  display_order_type: string;
  display_order_status: boolean;
}

export enum SortingProperty {
  CreationDate = 'created_at',
  OrderNumber = 'increment_id',
  OrderStatus = 'status'
}

export enum TimePeriodsFilters {
  lastSixMonths = 'lastSixMonths',
  currentYear = 'currentYear',
  prevYear = 'prevYear'
}
